import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { HeroContent, 
  HeroImage, 
  HeroMain, 
  HeroRow, 
  LogoContainer,
  BreadcrumbsMain,
  BreadcrumbsList,
  BreadcrumbsItem,
  PageTitle
} from './index.style'
import Container from '@components/Container'
import RichText from '@components/RichText'
import Spacer from '@components/Spacer'
import { Caption } from '@components/TextStyles'
import { GatsbyImage } from 'gatsby-plugin-image'
import Logo from '@svgs/Logo';
import AnimateSlideIn from '@components/animation/AnimateSlideIn'
import PageTransitionLink from '@components/PageTransitionLink'

const Hero = ({ name, title, image, bgColor, tColor, overlay = true, parentService, pageSeoTitle }) => {

  return (
    <HeroMain bgColor={bgColor} tColor={tColor}>
      {image && (
          <HeroImage>
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description}
              loading="eager"
              fetchPriority="high"
            />
          </HeroImage>
      )}
      <Container className="content">
        <Spacer size={[60, 100]} />
        <BreadcrumbsMain aria-label="Breadcrumb">
          <BreadcrumbsList>
            <BreadcrumbsItem>
              <PageTransitionLink to={`/`} underline={false}>Home</PageTransitionLink>
            </BreadcrumbsItem>
            <BreadcrumbsItem>
              <PageTransitionLink to={`what-we-do/`} underline={false}>What we do</PageTransitionLink>
            </BreadcrumbsItem>
            <BreadcrumbsItem>
              <PageTransitionLink to={`what-we-do/${parentService.slug}/`} underline={false}>{parentService.title}</PageTransitionLink>
            </BreadcrumbsItem>
            <BreadcrumbsItem>
              <strong>{name}</strong>
            </BreadcrumbsItem>
          </BreadcrumbsList>
        </BreadcrumbsMain>
        <PageTitle>{pageSeoTitle}</PageTitle>
        <Spacer size={[80, 180]} />
        <RichText
          content={title}
          paragraphSize="heading2Serif"
          maxWidth={12}
          as="span"
        />
        <Spacer size={60} />
      </Container>
    </HeroMain>
  )
}

Hero.propTypes = {
  data: PropTypes.object,
}

export default Hero
